/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCaseCreateDTO interface.
 */
export function instanceOfWarehouseCaseCreateDTO(value) {
    if (!('categoryId' in value) || value['categoryId'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    return true;
}
export function WarehouseCaseCreateDTOFromJSON(json) {
    return WarehouseCaseCreateDTOFromJSONTyped(json, false);
}
export function WarehouseCaseCreateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'warehousePackageId': json['warehousePackageId'] == null ? undefined : json['warehousePackageId'],
        'categoryId': json['categoryId'],
        'title': json['title'],
        'description': json['description'],
        'force': json['force'] == null ? undefined : json['force'],
    };
}
export function WarehouseCaseCreateDTOToJSON(json) {
    return WarehouseCaseCreateDTOToJSONTyped(json, false);
}
export function WarehouseCaseCreateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'warehousePackageId': value['warehousePackageId'],
        'categoryId': value['categoryId'],
        'title': value['title'],
        'description': value['description'],
        'force': value['force'],
    };
}
